import {atom, selector} from "recoil";
import {EQUser} from "../../models/serverModels/EQUser";
import {EQCompanyData, initializeCompanyData} from "../../models/serverModels/EQCompanyData";
import {recoilPersist} from "recoil-persist";

// memo 사용자 토큰

// fix 로컬스토리지에 임시 보관
const {persistAtom: localAtom} = recoilPersist({
  key: "recoil-persist",
  storage: localStorage,
});

const {persistAtom: sessionAtom} = recoilPersist({
  key: "sessionStorageKey",
  storage: sessionStorage,
});

export const tokenState = atom<string>({
  key: "tokenState",
  default: "",
  effects_UNSTABLE: [localAtom],
});

// export const tokenState = atom<string>({
//   key: "tokenState",
//   default: "",
// });

export const tokenSelector = selector<string>({
  key: "tokenSelector",
  get: ({get}) => get(tokenState),
});

export const isAuthState = atom<boolean>({
  key: "isAuthState",
  default: false,
  effects_UNSTABLE: [sessionAtom],
});

export const isAuthSelector = selector<boolean>({
  key: "isAuthSelector",
  get: ({get}) => get(isAuthState),
});

// memo 사용자 레벨 {1: super, 2: master, 3: admin, 4: user, 5: board}
export const levelState = atom<number>({
  key: "levelState",
  default: 0,
  effects_UNSTABLE: [sessionAtom],
});

export const levelSelector = selector<number>({
  key: "levelSelector",
  get: ({get}) => get(levelState),
});

export const userCompanyData = atom<EQCompanyData>({
  key: "userCompanyData",
  default: initializeCompanyData(),
  effects_UNSTABLE: [sessionAtom],
});

// memo 사용자 정보
export const userState = atom<EQUser>({
  key: "userState",
  default: {} as EQUser,
  effects_UNSTABLE: [sessionAtom],
});
export const userUidState = atom<number>({
  key: "userUidState",
  default: 0,
});

export const userSelector = selector<EQUser>({
  key: "userSelector",
  get: ({get}) => get(userState),
});
